<template>
   <header>
      <div class="wrapper">
         <div class="logo_menu">
            <div class="logo">
               <router-link
                   @click.native="responsiveMenu = false"
                   :to="{name: 'home' , params: {lang: $store.getters.locale }}"
               >
                  <img src="/vue/images/logo.png">
               </router-link>
            </div>
            <div class="right_part" :class="responsiveMenu ? 'active' : ''">
               <div class="menu_reg clearfix">
                  <ul>
                     <li>
                        <router-link
                            @click.native="responsiveMenu = false"
                            :to="{name: 'blog' , params: {lang: $store.getters.locale }}"
                        >{{ $store.getters.t('blog') }}
                        </router-link>
                     </li>
                     <li>
                        <router-link
                            @click.native="responsiveMenu = false"
                            :to="{name: 'contacts', params: {lang: $store.getters.locale }}"
                        >{{ $store.getters.t('contact') }}
                        </router-link>
                     </li>
                     <li>
                        <router-link
                            @click.native="responsiveMenu = false"
                            :to="{name: 'faq', params: {lang: $store.getters.locale }}"
                        >{{ $store.getters.t('FAQ') }}
                        </router-link>
                     </li>
                     <li>
                        <router-link
                            @click.native="responsiveMenu = false"
                            :to="{name: 'about_us', params: {lang: $store.getters.locale }}"
                        >{{ $store.getters.t('about_as') }}
                        </router-link>
                     </li>
                  </ul>
               </div>
               <div class="user_tariff" v-if="$store.getters.authUser"
                    :class="$store.getters.user.active_tariff.length > 0 ? $store.getters.user.active_tariff[0].style:''">
                  <span>{{$store.getters.user.active_tariff.length > 0 ? $store.getters.user.active_tariff[0].display_name:''}}</span>
               </div>
               <div class="login_lang">
                  <div class="login" v-if="!$store.getters.authUser">
                     <button
                         type="button"
                         v-on:click="$store.commit('loginModal', true); responsiveMenu = false"
                     >{{ $store.getters.t('login') }}
                     </button>
                  </div>
                  <div class="user_profile" v-else>
                     <router-link
                         @click.native="responsiveMenu = false"
                         :to="{name: 'profile', params: {lang: $store.getters.locale }}"
                     >
                        <img
                            :src="$store.getters.user.avatar ? $store.getters.user.avatar.image : $store.getters.user.photo"
                        >
                     </router-link>
                  </div>
                  <div class="lang" @click.stop="toogle = !toogle">
                     <div class="selected">
                        <span>{{ $store.getters.locale }}</span>
                     </div>
                     <div class="drop_lang" v-show="toogle">
                        <template v-for="language in $store.getters.languages">

                           <router-link
                               @click.native="responsiveMenu = false, changeLanguage(language.prefix)"
                               v-if="language.prefix !== $store.getters.locale"
                               :to="($route.name.match(/blog\.category/))?{name:'blog',params: {lang: language.prefix}}:{params: {lang: language.prefix}}"
                               :key="language.id"
                           >{{ language.language }}
                           </router-link>
                        </template>
                     </div>
                  </div>
               </div>
            </div>
            <div
                class="menu_icons"
                :class="responsiveMenu ? 'active' : ''"
                v-on:click="responsiveMenu = !responsiveMenu"
            >
               <div></div>
               <div></div>
               <div></div>
            </div>
         </div>
      </div>
   </header>
</template>
<script>
  export default {
    data() {
      return {
        toogle: false,
        responsiveMenu: false
      };
    },
    mounted() {
      this.onResize();
      window.onresize = e => {
        this.onResize();
      };
      document.body.onclick = e => {
        let langMenu = document
          .querySelector(".drop_lang")
          .getBoundingClientRect();
        if (
          e.clientY < langMenu.y ||
          e.clientY > langMenu.y + langMenu.height ||
          e.clientX < langMenu.x ||
          e.clientX > langMenu.x + langMenu.width
        ) {
          this.toogle = false;
        }
      };
    },
    methods: {
      onResize() {
        if(window.innerWidth < 641 ){
          this.responsiveMenu = false;
        }
      },
      changeLanguage(prefix) {
        this.$http({
          method: "post",
          url: `/api/setLocaleViaVue`,
          data: {prefix: prefix}
        }).then(res => {
          this.$store.commit("tariffs", res.data.tariffs);
        });
      }
    }
  };
</script>



// WEBPACK FOOTER //
// resources/js/components/layouts/header.vue